import React, { useEffect, useMemo, useRef, useState } from "react";
import "./Topbar.css";
import Api from "../Services/Api";

const getInitials = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Topbar = ({ page, onToggleMenu }) => {
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const menuRef = useRef(null);

  // 🔥 Ajuste aqui se sua chave for outra
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  }, []);

  const userName = user?.full_name || user?.name || "Usuário";
  const initials = getInitials(userName);

    const handleLogout = async () => {
        try {
            await Api.post("/auth/logout");
        } catch (e) {
            // mesmo se falhar, continua o fluxo
        }

        localStorage.removeItem("user");
        localStorage.removeItem("token");

        window.location.href = "/"; // ou "/login"
    };


  // fecha dropdown ao clicar fora
  useEffect(() => {
    const onClickOutside = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setOpenUserMenu(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button
          className="menu-toggle-btn"
          id="menuToggleBtn"
          onClick={onToggleMenu}
          type="button"
        >
          <span>☰</span>
          <span>Menu</span>
        </button>

        <div className="page-title">{page}</div>
      </div>

      {/* ✅ área direita */}
      <div className="topbar-right" ref={menuRef}>
        <button
          type="button"
          className="user-chip"
          onClick={() => setOpenUserMenu((v) => !v)}
          aria-haspopup="menu"
          aria-expanded={openUserMenu}
          title={userName}
        >
          <span className="user-avatar">{initials}</span>
        </button>

        {openUserMenu && (
          <div className="user-dropdown" role="menu">
            <div className="user-dropdown-header">
              <div className="user-avatar big">{initials}</div>
              <div className="user-meta">
                <div className="user-name">{userName}</div>
                {user?.email ? <div className="user-email">{user.email}</div> : null}
              </div>
            </div>

            <button className="logout-btn" type="button" onClick={handleLogout}>
              Sair
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Topbar;
